import { gql } from '@apollo/client';
const AUTOCOMPLETE_ATTRIBUTE = gql `
  query AutocompleteAttribute($attributeName: String!, $productCategoryId: ID!) {
    autocomplete {
      autocompleteAttribute(attributeName: $attributeName, productCategoryId: $productCategoryId) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export default AUTOCOMPLETE_ATTRIBUTE;
